import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Modal from "src/components/Modal"

const DialogFooter = ({
  cancelText,
  onCancel,
  isCancelDisabled = false,
  confirmText,
  onConfirm,
  isConfirmDisabled = false,
  isConfirmLoading = false,
  hasShadow = true,
}) => (
  <Modal.Footer>
    <div
      className={classNames(
        "relative -mx-4 -mb-4 flex gap-2 p-4 md:justify-end",
        { "shadow-top-md": hasShadow }
      )}
    >
      <div className="w-full md:w-min">
        <Button
          variant="tertiary"
          fullWidth
          onClick={onCancel}
          disabled={isCancelDisabled}
        >
          {cancelText}
        </Button>
      </div>
      <div className="w-full md:w-min">
        <Button
          variant="primary"
          fullWidth
          onClick={onConfirm}
          isLoading={isConfirmLoading}
          disabled={isConfirmDisabled}
        >
          {confirmText}
        </Button>
      </div>
    </div>
  </Modal.Footer>
)

DialogFooter.propTypes = {
  cancelText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  isCancelDisabled: PropTypes.bool,
  confirmText: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isConfirmDisabled: PropTypes.bool,
  isConfirmLoading: PropTypes.bool,
  hasShadow: PropTypes.bool,
}

export default DialogFooter
